<template>
	<div class="" @click="$sidebar.displaySidebar(false)">			
		<div class="row ">
            <div class="col-xl-8 mb-5 mb-xl-0">
                <div class="card shadow">
                    <div class="card-body">
						<div class="card-body-head">
 						<h4 class="mb-3 card-ttl">アカウント一覧</h4>
						<div class="cnt-wrap"><span class="cnt"> {{ totalUsers }}件</span></div>

						<div class="download-wrap">
							
							<button
								@click="csvExport"
								type="button" class="btn btn-download">
								CSVダウンロード
							</button>
						</div>
					</div>
	
						<div class="loading"  v-show="loading">受信中...</div>
						<div class="el-table__body-wrapper table-responsive">
							<table class='table table-striped el-table__body' v-if="!loading">
								<thead>
									<tr class="el-table__row">
										<th scope="col">ID</th>
										<th scope="col">ロール</th>
										<th scope="col">名前</th>
										<th scope="col">メールアドレス</th>
										<th scope="col">会社名</th>
										<th scope="col">&nbsp;</th>
									
									</tr>
								</thead>
								<tbody>
									<tr  v-for="user in userListData.data" :key="user.id" class="el-table__row">
										<td class="el-table_1_column_1"> {{ user.id }} </td>
										<td class="el-table_1_column_4" max-width="200px" > 
											<ul  class="comma-list">
												<li v-for="(r,k) in user.roles" :key="k">{{ r.name }}</li>
											</ul>
											</td>
										<td class="el-table_1_column_2" max-width="150px"> {{ user.name }} </td>
										<td class="el-table_1_column_3" max-width="150px" > {{ user.email }} </td>
										<td class="el-table_1_column_3" max-width="150px" > {{ user.personal_company_name }} </td>
										
										<td class="el-table_1_column_5">
											<div class="btn-wrap form-group text-center">
											<a v-show= "user.is_contractor == 1" class="btn btn-primary no-bg-btn" :href="'/contract/'">詳細</a>
											<a v-show= "user.is_contractor == 0" class="btn btn-primary no-bg-btn" :href="'/users/'+ user.id">詳細</a>
											<!--
       										<a class="btn btn-primary" :href="'/users/'+ user.id + '/edit'" v-show="permission_list['user-edit'] ? true:false" >編集</a>
											-->
											</div>
										</td>
									</tr>
								</tbody>
							</table>
						</div>	
					</div>
                </div>
            </div>
			<div class="pagination-wrap">
			<pagination align="center" :data="userListData" :show-disabled="true" :limit=10 @pagination-change-page="getResults">
				<span slot="prev-nav">&lt;</span>
				<span slot="next-nav">&gt;</span>
			</pagination>
			</div>
		</div>
	</div>
</template>

<script>
import pagination from 'laravel-vue-pagination'

export default {
	components: { pagination},
	props: ['UserList'],
	data() {
		return {
			// Our data object that holds the Laravel paginator data
			userListData: {},
			totalUsers:0,
			lastpage: null,
			siteId:null
			
		}
	},

	mounted() {
		// Fetch initial results
		this.siteId = window.PushL.site_id;
		console.log(this.siteId )
		this.userListData = JSON.parse(this.UserList)
		this.totalUsers = this.userListData.total;
		this.lastpage = this.userListData.last_page
		
	},

	methods: {
		// Our method to GET results from a Laravel endpoint
		getResults(page = 1) {
			if(this.lastpage != null && this.lastpage < page) return;
			axios.get('/users/'+this.siteId+'/list?page=' + page)
				.then(response => {
					this.userListData = response.data;
					this.lastpage = response.data.last_page
				});
		},

		csvExport() {
			let csvContent = "data:text/csv;charset=utf-8,";
			
			const len = this.userListData.data.length;
			console.log(len);
			if(len == 0) return;

			let arrData = [];
			for(let i=0; i<len; i++ ) {
				let user = this.userListData.data[i];
                let temp ={ 
					id:user.id, 
					Role:user.roles[0].name,
					Name:user.name,
					email: user.email,
					company: user.personal_company_name
				};
				arrData.push(temp);
			}

			csvContent += [
				Object.keys(arrData[0]).join(";"),
				...arrData.map(item => Object.values(item).join(";"))
			]
				.join("\n")
				.replace(/(^\[)|(\]$)/gm, "");

			const data = encodeURI(csvContent);
			const link = document.createElement("a");
			link.setAttribute("href", data);
			const fileName = 'userlist'
			link.setAttribute("download", fileName);
			link.click();
    	},
	}

}
</script>

<style scoped>

.comma-list li::after {
  content: ", ";
}

.comma-list li:last-child::after {
    content: "";
}
a {
	margin:0;
}

</style>